module.exports = __webpack_public_path__ + "static/media/logout.be2dca77.svg";